/**
 * Resa degli identificativi fiscali di un soggetto (V67).
 *
 * Prima si mostrava `piva ?? codice_fiscale`: uno in ALTERNATIVA all'altro.
 * Con la ditta individuale non basta più — persona fisica e ditta condividono
 * il CF e hanno la stessa ragione sociale, quindi nelle tendine comparivano due
 * voci identiche con due numeri diversi e nessuna etichetta: l'operatore non
 * poteva sapere quale fosse quale.
 *
 * Qui si mostrano ENTRAMBI i valori quando entrambi presenti, etichettati:
 *   «CF TZRCRL60S07E252B · P.IVA 01402990921»
 */
import i18n from '../i18n';

interface SoggettoFiscale {
  piva?: string | null;
  codice_fiscale?: string | null;
  /** Alias usato da `CustomerDetail` del dettaglio richiesta. */
  cf?: string | null;
}

/**
 * Stringa etichettata degli identificativi presenti, separati da `·`.
 * Ritorna stringa vuota se il soggetto non ne ha nessuno.
 */
export function identitaFiscale(soggetto: SoggettoFiscale): string {
  const cf = soggetto.codice_fiscale ?? soggetto.cf ?? null;
  const parti: string[] = [];
  if (cf) parti.push(i18n.t('anagrafiche.comune.cf_label', { val: cf }));
  if (soggetto.piva) parti.push(i18n.t('anagrafiche.comune.piva_label', { val: soggetto.piva }));
  return parti.join(' · ');
}
